// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse-data-v-b0ba3884{50%{opacity:.5}}.container-models[data-v-b0ba3884]{width:100%;display:grid;grid-template-columns:repeat(auto-fill,324px);grid-gap:2rem;gap:2rem;justify-content:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
